module.exports = __webpack_public_path__ + "dingbeauty-landing/img/system_03@1.e86c9a27.png";